const initializeAccessorySpotlights = (root = document) => {
  const sections = root.querySelectorAll('[data-accessory-spotlight]:not([data-accessory-spotlight-ready])');

  sections.forEach((section) => {
    section.dataset.accessorySpotlightReady = 'true';

    if (!section.classList.contains('accessory-spotlight--animated')) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.18 }
    );

    observer.observe(section);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeAccessorySpotlights());
document.addEventListener('shopify:section:load', (event) => initializeAccessorySpotlights(event.target));
